<span [class]="'tooltip ' + arrowClass" [ngClass]="{'ready': isReady&&checkedPosition, 'has-header': !!label, 'tooltip-padding':  tooltipPadding}"
	  cpClickOut [closeOnContextMenu]="openOnContextMenu" [closeOnDrag]="isTooltipOpen" [clickOutDisable]="disableClickOut" (clickOut)="onClickOut($event)">
	<kendo-popup #popup *ngIf="isTooltipOpen"
				 [popupClass]="arrowClass + ' ' + tooltipID"
				 [anchor]="anchor"
				 [offset]="offset"
				 [anchorAlign]="anchorAlign"
				 [popupAlign]="popupAlign"
				 [collision]="collision"
				 [animate]="false"
				 (close)="onClose($event)"
				 (open)="onOpen($event)"
				 (mouseenter)="onPopupMouseEnter()"
				 (mouseleave)="onPopupMouseLeave($event)">
		<div class="header" *ngIf="label">
			<div class="label">{{ label | cpTitleTranslate: labelParams }}</div>
			<div *ngIf="showCloseButton" class="close" (click)="onClose($event);"><i class="cp-sh-icon-close_btn"></i></div>
		</div>
		<div class="tooltip-content" [style.width]="width" [style.height]="height" [style.padding.px]="contentPadding">
			<ng-content></ng-content>
		</div>
	</kendo-popup>
</span>
